import { useMutation, useQueryClient } from "@tanstack/react-query";

import { appQueriesStore } from "@/app/api";
import { medicationRequestQueriesStore } from "@/features/my-meds/api";
import { testosteroneQueriesStore } from "@/features/testosterone-therapy/api";
import { errorToast } from "@/shared/ui";
import { cancelAppointment, consultationsQueriesStore } from "../api";

export const useCancelAppointment = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: cancelAppointment,
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey:
          consultationsQueriesStore.consultations.appointments._ctx.list._ctx
            .upcoming.queryKey,
      });
      void queryClient.invalidateQueries({
        queryKey: appQueriesStore.user.queryKey,
      });
      void queryClient.invalidateQueries({
        queryKey:
          medicationRequestQueriesStore.medicationRequest.list._ctx.available
            .queryKey,
      });
      void queryClient.invalidateQueries({
        queryKey: testosteroneQueriesStore.steps.queryKey,
      });
    },
    onError: errorToast,
  });
};
